[
  {
    "type": {
      "name": "ministry"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b37"
    },
    "id": 5,
    "name": "وزارة التجارة",
    "location": {
      "_id": "",
      "name": "ministry"
    },
    "manager": "manager",
    "image": "partners/Layer 8.svg",
    "image_sq": "partners/Layer 8_sq.svg",
    "data_counter": {
      "service": 145,
      "faq": 231,
      "isic": 29,
      "cases": 40,
      "library": 74
    },
    "active": true
  },
  {
    "type": {
      "name": "ministry"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b4e"
    },
    "id": 23,
    "name": "وزارة الصناعة والثروة المعدنية",
    "location": {
      "_id": "",
      "name": "ministry"
    },
    "manager": "manager",
    "image": "partners/logo_mim.svg",
    "image_sq": "partners/logo_mim_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 1048,
      "cases": 93,
      "library": 47
    },
    "active": true
  },
  {
    "type": {
      "name": "ministry"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b3c"
    },
    "id": 28,
    "name": "وزارة الشؤون البلدية والقروية والإسكان",
    "location": {
      "_id": "",
      "name": "ministry"
    },
    "manager": "manager",
    "image": "partners/Layer%205mdpi.svg",
    "image_sq": "partners/Layer%205mdpi_sq.svg",
    "data_counter": {
      "service": 51,
      "faq": 618,
      "isic": 18,
      "cases": 61,
      "library": 53
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b3b"
    },
    "id": 1,
    "name": "هيئة الزكاة والضريبة والجمارك",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/Layer%204.svg",
    "image_sq": "partners/Layer%204_sq.svg",
    "data_counter": {
      "service": 96,
      "faq": 318,
      "isic": 2,
      "cases": 11,
      "library": 13
    },
    "active": true
  },
  {
    "type": {
      "name": "ministry"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b38"
    },
    "id": 6,
    "name": "وزارة الموارد البشرية والتنمية الاجتماعية",
    "location": {
      "_id": "",
      "name": "ministry"
    },
    "manager": "manager",
    "image": "partners/0160.svg",
    "image_sq": "partners/0160_sq.svg",
    "data_counter": {
      "service": 56,
      "faq": 415,
      "isic": 18,
      "cases": 11,
      "library": 87
    },
    "active": true
  },
  {
    "type": {
      "name": "ministry"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b3a"
    },
    "id": 7,
    "name": "وزارة الاستثمار",
    "location": {
      "_id": "",
      "name": "ministry"
    },
    "manager": "manager",
    "image": "partners/Layer7.svg",
    "image_sq": "partners/Layer7_sq.svg",
    "data_counter": {
      "service": 54,
      "faq": 212,
      "isic": 2,
      "cases": 76,
      "library": 98
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b39"
    },
    "id": 3,
    "name": "المؤسسة العامة للتأمينات الإجتماعية",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/0362.svg",
    "image_sq": "partners/0362_sq.svg",
    "data_counter": {
      "service": 55,
      "faq": 73,
      "isic": 0,
      "cases": 58,
      "library": 55
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b41"
    },
    "id": 0,
    "name": "اتحاد الغرف السعودية",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/Layer%203ldpi.svg",
    "image_sq": "partners/Layer%203ldpi_sq.svg",
    "data_counter": {
      "service": 31,
      "faq": 75,
      "isic": 0,
      "cases": 26,
      "library": 43
    },
    "active": true
  },
  {
    "type": {
      "name": "ministry"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b44"
    },
    "id": 25,
    "name": "وزارة المالية",
    "location": {
      "_id": "",
      "name": "ministry"
    },
    "manager": "manager",
    "image": "partners/finance.png",
    "image_sq": "partners/finance_sq.png",
    "data_counter": {
      "service": 4,
      "faq": 187,
      "isic": 0,
      "cases": 65,
      "library": 76
    },
    "active": true
  },
  {
    "type": {
      "name": "ministry"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b3e"
    },
    "id": 12,
    "name": "وزارة التعليم",
    "location": {
      "_id": "",
      "name": "ministry"
    },
    "manager": "manager",
    "image": "partners/0136.svg",
    "image_sq": "partners/0136_sq.svg",
    "data_counter": {
      "service": 23,
      "faq": 11,
      "isic": 0,
      "cases": 20,
      "library": 10
    },
    "active": true
  },
  {
    "type": {
      "name": "ministry"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b43"
    },
    "id": 10,
    "name": "وزارة البيئة والمياه والزراعة",
    "location": {
      "_id": "",
      "name": "ministry"
    },
    "manager": "manager",
    "image": "partners/mewaLogo.svg",
    "image_sq": "partners/mewaLogo_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 9,
      "isic": 113,
      "cases": 76,
      "library": 12
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "6416f6fd0314c4b882b46046"
    },
    "id": 94,
    "name": "مركز الإقامة المميزة",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "PRC1.png",
    "image_sq": "PRC1_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 113,
      "isic": 0,
      "cases": 78,
      "library": 46
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "63078d513ba2155d8a0ff996"
    },
    "id": 58,
    "name": "الهيئة العامة للغذاء والدواء",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "dawa.svg",
    "image_sq": "dawa_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 25,
      "isic": 58,
      "cases": 34,
      "library": 87
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "630791e33ba2155d8a0ff99c"
    },
    "id": 61,
    "name": "هيئة السوق المالية",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "cpa.png",
    "image_sq": "cpa_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 73,
      "isic": 9,
      "cases": 70,
      "library": 64
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "62c430c8e180018466b15b1d"
    },
    "id": 41,
    "name": "السجل الموحد للحقوق على الأموال المنقولة",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "unified-registry.svg",
    "image_sq": "unified-registry_sq.svg",
    "data_counter": {
      "service": 5,
      "faq": 49,
      "isic": 0,
      "cases": 90,
      "library": 10
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "6352bcfa4cdcc7fde513e342"
    },
    "id": 86,
    "name": "الهيئة العامة للصناعات العسكرية ",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/military.png",
    "image_sq": "partners/military_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 74,
      "cases": 56,
      "library": 19
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "630797473ba2155d8a0ff9a6"
    },
    "id": 66,
    "name": "الهيئة السعودية للمقيّمين المعتمدين",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "taqeem.png",
    "image_sq": "taqeem_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 65,
      "isic": 4,
      "cases": 9,
      "library": 45
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "62c430c8e180018466b15b1c"
    },
    "id": 40,
    "name": "قوائم",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "qawaem-logo.svg",
    "image_sq": "qawaem-logo.svg",
    "data_counter": {
      "service": 5,
      "faq": 37,
      "isic": 0,
      "cases": 13,
      "library": 67
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "6352bcfa4cdcc7fde513e33c"
    },
    "id": 80,
    "name": "الهيئة العامة للأرصاد وحماية البيئة",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/meterology.png",
    "image_sq": "partners/meterology_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 53,
      "cases": 9,
      "library": 95
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b62"
    },
    "id": 54,
    "name": "الهيئة العامة للنقل",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "0328.svg",
    "image_sq": "0328_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 52,
      "cases": 6,
      "library": 99
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b5f"
    },
    "id": 50,
    "name": "هيئة الاتصالات وتقنية المعلومات",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/citc_logo.svg",
    "image_sq": "partners/citc_logo_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 51,
      "cases": 68,
      "library": 17
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "6307940c3ba2155d8a0ff9a0"
    },
    "id": 63,
    "name": "الهيئة العامة للطيران المدني",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "gaca.svg",
    "image_sq": "gaca_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 6,
      "isic": 44,
      "cases": 75,
      "library": 42
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b4c"
    },
    "id": 2,
    "name": "مُدد",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/mudad_logo.svg",
    "image_sq": "partners/mudad_logo_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 49,
      "isic": 0,
      "cases": 47,
      "library": 22
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b55"
    },
    "id": 43,
    "name": "الهيئة العامة للإعلام المرئي والمسموع",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/0339.svg",
    "image_sq": "partners/0339_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 11,
      "isic": 33,
      "cases": 29,
      "library": 35
    },
    "active": true
  },
  {
    "type": {
      "name": "ministry"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b48"
    },
    "id": 22,
    "name": "وزارة الصحة",
    "location": {
      "_id": "",
      "name": "ministry"
    },
    "manager": "manager",
    "image": "partners/moh.png",
    "image_sq": "partners/moh_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 43,
      "cases": 87,
      "library": 32
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b5b"
    },
    "id": 52,
    "name": "البنك المركزي السعودي",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/0034.svg",
    "image_sq": "partners/0034_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 38,
      "cases": 48,
      "library": 79
    },
    "active": true
  },
  {
    "type": {
      "name": "ministry"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b40"
    },
    "id": 8,
    "name": "وزارة الإعلام",
    "location": {
      "_id": "",
      "name": "ministry"
    },
    "manager": "manager",
    "image": "partners/0166.svg",
    "image_sq": "partners/0166_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 35,
      "cases": 79,
      "library": 74
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "630794dd3ba2155d8a0ff9a2"
    },
    "id": 64,
    "name": "الهيئة الملكية للجبيل وينبع",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "jubail.svg",
    "image_sq": "jubail_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 34,
      "isic": 0,
      "cases": 67,
      "library": 20
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "6352bcfa4cdcc7fde513e330"
    },
    "id": 68,
    "name": "الهيئة العليا للأمن الصناعي",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/hcis.png",
    "image_sq": "partners/hcis_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 33,
      "cases": 37,
      "library": 30
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "6307961d3ba2155d8a0ff9a4"
    },
    "id": 65,
    "name": "الهيئة العامة للترفيه",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "entertainment.svg",
    "image_sq": "entertainment_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 25,
      "isic": 6,
      "cases": 5,
      "library": 41
    },
    "active": true
  },
  {
    "type": {
      "name": "ministry"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b49"
    },
    "id": 20,
    "name": "وزارة السياحة",
    "location": {
      "_id": "",
      "name": "ministry"
    },
    "manager": "manager",
    "image": "partners/0417.svg",
    "image_sq": "partners/0417_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 4,
      "isic": 25,
      "cases": 44,
      "library": 7
    },
    "active": true
  },
  {
    "type": {
      "name": "ministry"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b51"
    },
    "id": 17,
    "name": "وزارة الداخلية",
    "location": {
      "_id": "",
      "name": "ministry"
    },
    "manager": "manager",
    "image": "partners/0117.svg",
    "image_sq": "partners/0117_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 27,
      "cases": 14,
      "library": 26
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "630791033ba2155d8a0ff99a"
    },
    "id": 60,
    "name": "الهيئة السعودية للمهندسين",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "sce.svg",
    "image_sq": "sce_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 6,
      "isic": 19,
      "cases": 18,
      "library": 62
    },
    "active": true
  },
  {
    "type": {
      "name": "ministry"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b4b"
    },
    "id": 27,
    "name": "وزارة الطاقة",
    "location": {
      "_id": "",
      "name": "ministry"
    },
    "manager": "manager",
    "image": "partners/energy.png",
    "image_sq": "partners/energy_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 22,
      "cases": 47,
      "library": 67
    },
    "active": true
  },
  {
    "type": {
      "name": "ministry"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b4f"
    },
    "id": 19,
    "name": "وزارة الرياضة",
    "location": {
      "_id": "",
      "name": "ministry"
    },
    "manager": "manager",
    "image": "partners/0173.svg",
    "image_sq": "partners/0173_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 16,
      "cases": 2,
      "library": 67
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "6352bcfa4cdcc7fde513e331"
    },
    "id": 69,
    "name": "الهيئة العامة للمساحة والمعلومات الجيومكانية",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/gasgi.svg",
    "image_sq": "partners/gasgi_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 16,
      "cases": 14,
      "library": 7
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "6352bcfa4cdcc7fde513e33e"
    },
    "id": 82,
    "name": "هيئة الرقابة النووية والإشعاعية",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/nrrc.svg",
    "image_sq": "partners/nrrc_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 12,
      "cases": 70,
      "library": 21
    },
    "active": true
  },
  {
    "type": {
      "name": "ministry"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b45"
    },
    "id": 24,
    "name": "وزارة العدل",
    "location": {
      "_id": "",
      "name": "ministry"
    },
    "manager": "manager",
    "image": "partners/logoarbeta.svg",
    "image_sq": "partners/logoarbeta_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 11,
      "cases": 75,
      "library": 18
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b5a"
    },
    "id": 45,
    "name": "الدفاع المدني",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/998-logo.png",
    "image_sq": "partners/998-logo_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 6,
      "isic": 3,
      "cases": 91,
      "library": 68
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b61"
    },
    "id": 53,
    "name": "الشركة السعودية للكهرباء",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "Saudi-Electricity-Company-01.svg",
    "image_sq": "Saudi-Electricity-Company-01_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 9,
      "cases": 19,
      "library": 55
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "6352bcfa4cdcc7fde513e332"
    },
    "id": 70,
    "name": "الهيئة السعودية للمواصفات والمقاييس والجودة",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/saso.png",
    "image_sq": "partners/saso_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 9,
      "cases": 76,
      "library": 8
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "6352bcfa4cdcc7fde513e339"
    },
    "id": 77,
    "name": "الاتحاد السعودي للأمن السيبراني والبرمجة والدرونز",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/cybersecurity.png",
    "image_sq": "partners/cybersecurity_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 9,
      "cases": 99,
      "library": 58
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "630793023ba2155d8a0ff99e"
    },
    "id": 62,
    "name": "الهيئة العامة للإحصاء",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "hissa.svg",
    "image_sq": "hissa_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 7,
      "isic": 1,
      "cases": 1,
      "library": 60
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "63078bfd3ba2155d8a0ff994"
    },
    "id": 57,
    "name": "المؤسسة العامة للتدريب التقني والمهني",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "tech-training.svg",
    "image_sq": "tech-training_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 4,
      "isic": 4,
      "cases": 87,
      "library": 23
    },
    "active": true
  },
  {
    "type": {
      "name": "ministry"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b4a"
    },
    "id": 26,
    "name": "وزارة النقل والخدمات اللوجستية",
    "location": {
      "_id": "",
      "name": "ministry"
    },
    "manager": "manager",
    "image": "partners/transport.svg",
    "image_sq": "partners/transport_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 7,
      "cases": 23,
      "library": 1
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "6352bcfa4cdcc7fde513e343"
    },
    "id": 87,
    "name": "المركز السعودي لكفاءة الطاقة ",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/efficiency.svg",
    "image_sq": "partners/efficiency_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 6,
      "cases": 24,
      "library": 86
    },
    "active": true
  },
  {
    "type": {
      "name": "ministry"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b4d"
    },
    "id": 14,
    "name": "وزارة الحج والعمرة",
    "location": {
      "_id": "",
      "name": "ministry"
    },
    "manager": "manager",
    "image": "partners/haj.png",
    "image_sq": "partners/haj_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 5,
      "cases": 33,
      "library": 55
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "6352bcfa4cdcc7fde513e32f"
    },
    "id": 67,
    "name": "الإدارة العامة للمرور",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/maroor.png",
    "image_sq": "partners/maroor_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 5,
      "cases": 15,
      "library": 42
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "6352bcfa4cdcc7fde513e334"
    },
    "id": 72,
    "name": "الهيئة السعودية للمحاسبين القانونيين",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/nodatayet.nodatayet",
    "image_sq": "partners/nodatayet_sq.nodatayet",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 5,
      "cases": 22,
      "library": 36
    },
    "active": true
  },
  {
    "type": {
      "name": "ministry"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b3d"
    },
    "id": 13,
    "name": "وزارة الثقافة",
    "location": {
      "_id": "",
      "name": "ministry"
    },
    "manager": "manager",
    "image": "partners/logo_dark.png",
    "image_sq": "partners/logo_dark_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 4,
      "cases": 66,
      "library": 38
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b58"
    },
    "id": 44,
    "name": "مواني",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/0329.svg",
    "image_sq": "partners/0329_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 3,
      "cases": 21,
      "library": 10
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "6352bcfa4cdcc7fde513e338"
    },
    "id": 76,
    "name": "مركز الملك عبدالعزيز للخيل العربية الأصيلة بديراب",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/horses.png",
    "image_sq": "partners/horses_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 3,
      "cases": 63,
      "library": 80
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "6352bcfa4cdcc7fde513e33d"
    },
    "id": 81,
    "name": "المؤسسة العامة للحبوب",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/sago.png",
    "image_sq": "partners/sago_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 3,
      "cases": 25,
      "library": 97
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "63078f5b3ba2155d8a0ff998"
    },
    "id": 59,
    "name": "المديرية العامة للجوازات",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "jawazat.png",
    "image_sq": "jawazat.png",
    "data_counter": {
      "service": 0,
      "faq": 2,
      "isic": 0,
      "cases": 36,
      "library": 22
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b59"
    },
    "id": 51,
    "name": "الهيئة السعودية للملكية الفكرية",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/0345.svg",
    "image_sq": "partners/0345_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 2,
      "cases": 98,
      "library": 44
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "6352bcfa4cdcc7fde513e335"
    },
    "id": 73,
    "name": "الهيئة السعودية للحياة الفطرية",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/wildlife.png",
    "image_sq": "partners/wildlife_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 2,
      "cases": 65,
      "library": 54
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "6352bcfa4cdcc7fde513e336"
    },
    "id": 74,
    "name": "المطارات والشركات المشغلة",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/Matarat.png",
    "image_sq": "partners/Matarat_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 2,
      "cases": 20,
      "library": 67
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "63078a093ba2155d8a0ff991"
    },
    "id": 56,
    "name": "الهيئة السعودية للمقاولين",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "SAC.png",
    "image_sq": "SAC_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 1,
      "isic": 0,
      "cases": 26,
      "library": 60
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b57"
    },
    "id": 42,
    "name": "منشاّت",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/0325.svg",
    "image_sq": "partners/0325_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 1,
      "cases": 89,
      "library": 69
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "6352bcfa4cdcc7fde513e333"
    },
    "id": 71,
    "name": "الهيئة العامة للعقار",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/realestate.png",
    "image_sq": "partners/realestate_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 1,
      "cases": 48,
      "library": 19
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "6352bcfa4cdcc7fde513e337"
    },
    "id": 75,
    "name": "هيئة التراث",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/heritage.png",
    "image_sq": "partners/heritage_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 1,
      "cases": 41,
      "library": 6
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "6352bcfa4cdcc7fde513e33a"
    },
    "id": 78,
    "name": "المركز الوطني للطب البديل والتكميلي",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/nccam.png",
    "image_sq": "partners/nccam_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 1,
      "cases": 58,
      "library": 28
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "6352bcfa4cdcc7fde513e33b"
    },
    "id": 79,
    "name": "الهيئة السعودية للتخصصات الصحية",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/healthcommission.svg",
    "image_sq": "partners/healthcommission_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 1,
      "cases": 41,
      "library": 18
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "6352bcfa4cdcc7fde513e33f"
    },
    "id": 83,
    "name": "هيئة المساحة الجيولوجية السعودية ",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/sgs.png",
    "image_sq": "partners/sgs_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 1,
      "cases": 20,
      "library": 74
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "6352bcfa4cdcc7fde513e340"
    },
    "id": 84,
    "name": "مدينة الملك عبد الله للطاقة الذرية والمتجددة ",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/atom.png",
    "image_sq": "partners/atom_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 1,
      "cases": 39,
      "library": 51
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "6352bcfa4cdcc7fde513e341"
    },
    "id": 85,
    "name": "اللجنة الدائمة لمراكز التحكيم السعودية ",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/arbitration.png",
    "image_sq": "partners/arbitration_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 1,
      "cases": 40,
      "library": 50
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "6352bcfa4cdcc7fde513e345"
    },
    "id": 89,
    "name": "هيئة المدن الاقتصادية",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/ecza.png",
    "image_sq": "partners/ecza_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 1,
      "cases": 39,
      "library": 18
    },
    "active": true
  },
  {
    "type": {
      "name": "ministry"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b3f"
    },
    "id": 15,
    "name": "وزارة الحرس الوطني",
    "location": {
      "_id": "",
      "name": "ministry"
    },
    "manager": "manager",
    "image": "partners/sang-logo.png",
    "image_sq": "partners/sang-logo_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 0,
      "cases": 66,
      "library": 7
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b42"
    },
    "id": 4,
    "name": "قوى",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/qiwa-logo-ar-new.svg",
    "image_sq": "partners/qiwa-logo-ar-new_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 0,
      "cases": 18,
      "library": 19
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b56"
    },
    "id": 46,
    "name": "الهيئة السعودية للبيانات والذكاء الاصطناعي",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/0191.svg",
    "image_sq": "partners/0191_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 0,
      "cases": 40,
      "library": 67
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b5e"
    },
    "id": 48,
    "name": "هيئة الرقابة ومكافحة الفساد (نزاهة)",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/nazaha.png",
    "image_sq": "partners/nazaha_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 0,
      "cases": 30,
      "library": 4
    },
    "active": true
  },
  {
    "type": {
      "name": "ministry"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b46"
    },
    "id": 9,
    "name": "وزارة الاتصالات وتقنية المعلومات",
    "location": {
      "_id": "",
      "name": "ministry"
    },
    "manager": "manager",
    "image": "partners/commIT.png",
    "image_sq": "partners/commIT_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 0,
      "cases": 67,
      "library": 21
    },
    "active": true
  },
  {
    "type": {
      "name": "ministry"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b47"
    },
    "id": 21,
    "name": "وزارة الشؤون الإسلامية والدعوة والإرشاد",
    "location": {
      "_id": "",
      "name": "ministry"
    },
    "manager": "manager",
    "image": "partners/Islam.png",
    "image_sq": "partners/Islam_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 0,
      "cases": 27,
      "library": 95
    },
    "active": true
  },
  {
    "type": {
      "name": "ministry"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b50"
    },
    "id": 11,
    "name": "وزارة الاقتصاد والتخطيط",
    "location": {
      "_id": "",
      "name": "ministry"
    },
    "manager": "manager",
    "image": "partners/last_logo.svg",
    "image_sq": "partners/last_logo_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 0,
      "cases": 72,
      "library": 57
    },
    "active": true
  },
  {
    "type": {
      "name": "ministry"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b53"
    },
    "id": 16,
    "name": "وزارة الخارجية",
    "location": {
      "_id": "",
      "name": "ministry"
    },
    "manager": "manager",
    "image": "partners/mofa_logo_h.svg",
    "image_sq": "partners/mofa_logo_h_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 0,
      "cases": 17,
      "library": 65
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b5c"
    },
    "id": 47,
    "name": "المركز الوطني للتنافسية",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/0307.svg",
    "image_sq": "partners/0307_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 0,
      "cases": 77,
      "library": 64
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b5d"
    },
    "id": 49,
    "name": "سبل",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/Logo-SPL.svg",
    "image_sq": "partners/Logo-SPL_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 0,
      "cases": 19,
      "library": 67
    },
    "active": true
  },
  {
    "type": {
      "name": "ministry"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b52"
    },
    "id": 18,
    "name": "وزارة الدفاع",
    "location": {
      "_id": "",
      "name": "ministry"
    },
    "manager": "manager",
    "image": "partners/defence.png",
    "image_sq": "partners/defence_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 0,
      "cases": 49,
      "library": 2
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "62bdf4748deaee9a80270b60"
    },
    "id": 55,
    "name": "شركة المياه الوطنية",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "nwc-logo_1.png",
    "image_sq": "nwc-logo_1_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 0,
      "cases": 99,
      "library": 31
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "6408a99050484cef9c6e9f25"
    },
    "id": 91,
    "name": "المركز الوطني للتعليم الإلكتروني",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "nelcLogo2020.png",
    "image_sq": "nelcLogo2020_sq.png",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 0,
      "cases": 93,
      "library": 45
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "6408a99050484cef9c6e9f26"
    },
    "id": 92,
    "name": "هيئة تقويم التعليم والتدريب",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "NEW-ETEC-LOGO.svg",
    "image_sq": "NEW-ETEC-LOGO_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 0,
      "cases": 63,
      "library": 18
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "6408a99050484cef9c6e9f27"
    },
    "id": 93,
    "name": "شركة تطوير للمباني",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "tbcnew-01.svg",
    "image_sq": "tbcnew-01.svg",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 0,
      "cases": 77,
      "library": 68
    },
    "active": true
  },
  {
    "type": {
      "name": "entity"
    },
    "_id": {
      "$oid": "6416f8350314c4b882b4604b"
    },
    "id": 95,
    "name": "مركز تطوير المناهج",
    "location": {
      "_id": "",
      "name": "entity"
    },
    "manager": "manager",
    "image": "partners/0136.svg",
    "image_sq": "partners/0136_sq.svg",
    "data_counter": {
      "service": 0,
      "faq": 0,
      "isic": 0,
      "cases": 53,
      "library": 98
    }
  },
  {
    "type": {
      "name": "Ou"
    },
    "id": 101,
    "name": "السجل التجاري",
    "image": "pi pi-file",
    "image_sq": "pi pi-file",
    "data_counter": {
      "service": 145,
      "faq": 231,
      "isic": 29,
      "cases": 40,
      "library": 74
    },
    "parent": {
      "type": {
        "name": "ministry"
      },
      "_id": {
        "$oid": "62bdf4748deaee9a80270b37"
      },
      "id": 5,
      "name": "وزارة التجارة",
      "location": {
        "_id": "",
        "name": "ministry"
      },
      "manager": "manager",
      "image": "partners/Layer 8.svg",
      "image_sq": "partners/Layer 8_sq.svg",
      "data_counter": {
        "service": 145,
        "faq": 231,
        "isic": 29,
        "cases": 40,
        "library": 74
      },
      "active": true
    }
  },
  {
    "type": {
      "name": "Ou"
    },
    "id": 102,
    "name": "خدمات السجل التجاري للمؤسسات",
    "image": "pi pi-file",
    "image_sq": "pi pi-file",
    "data_counter": {
      "service": 145,
      "faq": 231,
      "isic": 29,
      "cases": 40,
      "library": 74
    },
    "parent": {
      "type": {
        "name": "Ou"
      },
      "id": 101,
      "name": "السجل التجاري",
      "image": "pi pi-file",
      "image_sq": "pi pi-file",
      "data_counter": {
        "service": 145,
        "faq": 231,
        "isic": 29,
        "cases": 40,
        "library": 74
      },
      "parent": {
        "type": {
          "name": "ministry"
        },
        "_id": {
          "$oid": "62bdf4748deaee9a80270b37"
        },
        "id": 5,
        "name": "وزارة التجارة",
        "location": {
          "_id": "",
          "name": "ministry"
        },
        "manager": "manager",
        "image": "partners/Layer 8.svg",
        "image_sq": "partners/Layer 8_sq.svg",
        "data_counter": {
          "service": 145,
          "faq": 231,
          "isic": 29,
          "cases": 40,
          "library": 74
        },
        "active": true
      }
    }
  },
  {
    "type": {
      "name": "Ou"
    },
    "id": 103,
    "name": "التراخيص",
    "image": "pi pi-file",
    "image_sq": "pi pi-file",
    "data_counter": {
      "service": 145,
      "faq": 231,
      "isic": 29,
      "cases": 40,
      "library": 74
    },
    "parent": {
      "type": {
        "name": "Ou"
      },
      "id": 101,
      "name": "السجل التجاري",
      "image": "pi pi-file",
      "image_sq": "pi pi-file",
      "data_counter": {
        "service": 145,
        "faq": 231,
        "isic": 29,
        "cases": 40,
        "library": 74
      },
      "parent": {
        "type": {
          "name": "ministry"
        },
        "_id": {
          "$oid": "62bdf4748deaee9a80270b37"
        },
        "id": 5,
        "name": "وزارة التجارة",
        "location": {
          "_id": "",
          "name": "ministry"
        },
        "manager": "manager",
        "image": "partners/Layer 8.svg",
        "image_sq": "partners/Layer 8_sq.svg",
        "data_counter": {
          "service": 145,
          "faq": 231,
          "isic": 29,
          "cases": 40,
          "library": 74
        },
        "active": true
      }
    }
  },
  {
    "type": {
      "name": "Ou"
    },
    "id": 104,
    "name": "خدمات السجل التجاري للشركات",
    "image": "pi pi-file",
    "image_sq": "pi pi-file",
    "data_counter": {
      "service": 145,
      "faq": 231,
      "isic": 29,
      "cases": 40,
      "library": 74
    },
    "parent": {
      "type": {
        "name": "Ou"
      },
      "id": 101,
      "name": "السجل التجاري",
      "image": "pi pi-file",
      "image_sq": "pi pi-file",
      "data_counter": {
        "service": 145,
        "faq": 231,
        "isic": 29,
        "cases": 40,
        "library": 74
      },
      "parent": {
        "type": {
          "name": "ministry"
        },
        "_id": {
          "$oid": "62bdf4748deaee9a80270b37"
        },
        "id": 5,
        "name": "وزارة التجارة",
        "location": {
          "_id": "",
          "name": "ministry"
        },
        "manager": "manager",
        "image": "partners/Layer 8.svg",
        "image_sq": "partners/Layer 8_sq.svg",
        "data_counter": {
          "service": 145,
          "faq": 231,
          "isic": 29,
          "cases": 40,
          "library": 74
        },
        "active": true
      }
    }
  },
  {
    "type": {
      "name": "Ou"
    },
    "id": 105,
    "name": "خدمات السجل التجاري الأخرى",
    "image": "pi pi-file",
    "image_sq": "pi pi-file",
    "data_counter": {
      "service": 145,
      "faq": 231,
      "isic": 29,
      "cases": 40,
      "library": 74
    },
    "parent": {
      "type": {
        "name": "Ou"
      },
      "id": 101,
      "name": "السجل التجاري",
      "image": "pi pi-file",
      "image_sq": "pi pi-file",
      "data_counter": {
        "service": 145,
        "faq": 231,
        "isic": 29,
        "cases": 40,
        "library": 74
      },
      "parent": {
        "type": {
          "name": "ministry"
        },
        "_id": {
          "$oid": "62bdf4748deaee9a80270b37"
        },
        "id": 5,
        "name": "وزارة التجارة",
        "location": {
          "_id": "",
          "name": "ministry"
        },
        "manager": "manager",
        "image": "partners/Layer 8.svg",
        "image_sq": "partners/Layer 8_sq.svg",
        "data_counter": {
          "service": 145,
          "faq": 231,
          "isic": 29,
          "cases": 40,
          "library": 74
        },
        "active": true
      }
    }
  },
  {
    "type": {
      "name": "Ou"
    },
    "id": 106,
    "name": "استخرج رمزك التجاري",
    "image": "pi pi-file",
    "image_sq": "pi pi-file",
    "data_counter": {
      "service": 145,
      "faq": 231,
      "isic": 29,
      "cases": 40,
      "library": 74
    },
    "parent": {
      "type": {
        "name": "Ou"
      },
      "id": 101,
      "name": "السجل التجاري",
      "image": "pi pi-file",
      "image_sq": "pi pi-file",
      "data_counter": {
        "service": 145,
        "faq": 231,
        "isic": 29,
        "cases": 40,
        "library": 74
      },
      "parent": {
        "type": {
          "name": "ministry"
        },
        "_id": {
          "$oid": "62bdf4748deaee9a80270b37"
        },
        "id": 5,
        "name": "وزارة التجارة",
        "location": {
          "_id": "",
          "name": "ministry"
        },
        "manager": "manager",
        "image": "partners/Layer 8.svg",
        "image_sq": "partners/Layer 8_sq.svg",
        "data_counter": {
          "service": 145,
          "faq": 231,
          "isic": 29,
          "cases": 40,
          "library": 74
        },
        "active": true
      }
    }
  },

  {
    "type": {
      "name": "Ou"
    },
    "id": 107,
    "name": "السعودي",
    "image": "pi pi-file",
    "image_sq": "pi pi-file",
    "data_counter": {
      "service": 145,
      "faq": 231,
      "isic": 29,
      "cases": 40,
      "library": 74
    },
    "parent": {
    "type": {
      "name": "Ou"
    },
    "id": 102,
    "name": "خدمات السجل التجاري للمؤسسات",
    "image": "pi pi-file",
    "image_sq": "pi pi-file",
    "data_counter": {
      "service": 145,
      "faq": 231,
      "isic": 29,
      "cases": 40,
      "library": 74
    },
    "parent": {
      "type": {
        "name": "Ou"
      },
      "id": 101,
      "name": "السجل التجاري",
      "image": "pi pi-file",
      "image_sq": "pi pi-file",
      "data_counter": {
        "service": 145,
        "faq": 231,
        "isic": 29,
        "cases": 40,
        "library": 74
      },
      "parent": {
        "type": {
          "name": "ministry"
        },
        "_id": {
          "$oid": "62bdf4748deaee9a80270b37"
        },
        "id": 5,
        "name": "وزارة التجارة",
        "location": {
          "_id": "",
          "name": "ministry"
        },
        "manager": "manager",
        "image": "partners/Layer 8.svg",
        "image_sq": "partners/Layer 8_sq.svg",
        "data_counter": {
          "service": 145,
          "faq": 231,
          "isic": 29,
          "cases": 40,
          "library": 74
        },
        "active": true
      }
    }
  }
  },

  {
    "type": {
      "name": "Ou"
    },
    "id": 108,
    "name": "الخليجي",
    "image": "pi pi-file",
    "image_sq": "pi pi-file",
    "data_counter": {
      "service": 145,
      "faq": 231,
      "isic": 29,
      "cases": 40,
      "library": 74
    },
    "parent": {
    "type": {
      "name": "Ou"
    },
    "id": 102,
    "name": "خدمات السجل التجاري للمؤسسات",
    "image": "pi pi-file",
    "image_sq": "pi pi-file",
    "data_counter": {
      "service": 145,
      "faq": 231,
      "isic": 29,
      "cases": 40,
      "library": 74
    },
    "parent": {
      "type": {
        "name": "Ou"
      },
      "id": 101,
      "name": "السجل التجاري",
      "image": "pi pi-file",
      "image_sq": "pi pi-file",
      "data_counter": {
        "service": 145,
        "faq": 231,
        "isic": 29,
        "cases": 40,
        "library": 74
      },
      "parent": {
        "type": {
          "name": "ministry"
        },
        "_id": {
          "$oid": "62bdf4748deaee9a80270b37"
        },
        "id": 5,
        "name": "وزارة التجارة",
        "location": {
          "_id": "",
          "name": "ministry"
        },
        "manager": "manager",
        "image": "partners/Layer 8.svg",
        "image_sq": "partners/Layer 8_sq.svg",
        "data_counter": {
          "service": 145,
          "faq": 231,
          "isic": 29,
          "cases": 40,
          "library": 74
        },
        "active": true
      }
    }
  }
  },

  {
    "type": {
      "name": "Ou"
    },
    "id": 109,
    "name": "الأجنبي",
    "image": "pi pi-file",
    "image_sq": "pi pi-file",
    "data_counter": {
      "service": 145,
      "faq": 231,
      "isic": 29,
      "cases": 40,
      "library": 74
    },
    "parent": {
    "type": {
      "name": "Ou"
    },
    "id": 102,
    "name": "خدمات السجل التجاري للمؤسسات",
    "image": "pi pi-file",
    "image_sq": "pi pi-file",
    "data_counter": {
      "service": 145,
      "faq": 231,
      "isic": 29,
      "cases": 40,
      "library": 74
    },
    "parent": {
      "type": {
        "name": "Ou"
      },
      "id": 101,
      "name": "السجل التجاري",
      "image": "pi pi-file",
      "image_sq": "pi pi-file",
      "data_counter": {
        "service": 145,
        "faq": 231,
        "isic": 29,
        "cases": 40,
        "library": 74
      },
      "parent": {
        "type": {
          "name": "ministry"
        },
        "_id": {
          "$oid": "62bdf4748deaee9a80270b37"
        },
        "id": 5,
        "name": "وزارة التجارة",
        "location": {
          "_id": "",
          "name": "ministry"
        },
        "manager": "manager",
        "image": "partners/Layer 8.svg",
        "image_sq": "partners/Layer 8_sq.svg",
        "data_counter": {
          "service": 145,
          "faq": 231,
          "isic": 29,
          "cases": 40,
          "library": 74
        },
        "active": true
      }
    }
  }
  }
]